export default __webpack_public_path__ + "static/media/message.cd20728e.svg";